import {useLayoutStore} from "@/store/layout"

export const $getCurrentModule = () => {
    const module = useLayoutStore().currentModule
    return module ? appModules[module] as AppModule : null
}

export const $getModuleIcon = (module?: string): string | null => {
    if (!module) return $getCurrentModule()?.icon ?? null
    return appModules[module]?.icon ?? null
}

export const $getModuleColor = (module: string | null = null): string | null => {
    if (!module) return $getCurrentModule()?.color ?? $getCurrentModule()?.name ?? null
    return appModules[module]?.color ?? module
}

const userModule = (name: string = 'users'): AppModule => ({
    name,
    icon: 'users',
    color: 'users',
    search: true
})

export const appModules: AppModules = {
    dashboard: {
        name: 'dashboard',
        icon: 'home',
        color: 'app'
    },
    users: userModule(),
    organisationUsers: userModule('organisationUsers'),
    organisationProjects: {
        name: 'organisationProjects',
        icon: 'clipboard',
        color: 'app',
        search: true,
    },
    projects: {
        name: 'projects',
        icon: 'clipboard',
        color: 'app',
        search: true,
    },
    organisations: {
        name: 'organisations',
        icon: 'building-office',
        search: {
            detail: 'organisations-id-organisationBaseData'
        },
    },
    contractors: {
        name: 'contractors',
        icon: 'truck',
        color: 'app',
    },
    settings: {
        name: 'settings',
        icon: 'cog',
    },
    system: {
        name: 'system',
        icon: 'cpu-chip',
    },
    projectContainers: {
        name: 'projectContainers',
        icon: 'archive-box',
        color: 'stone',
    },
    containers: {
        name: 'containers',
        icon: 'archive-box',
        color: 'stone',
    },
    projectWastes: {
        name: 'projectWastes',
        icon: 'trash',
        color: 'red',
        search: true,
    },
    wastes: {
        name: 'wastes',
        icon: 'trash',
        color: 'red',
        search: true,
    },
    projectOrders: {
        name: 'projectOrders',
        icon: 'clipboard-document-list',
        color: 'amber',
        search: true,
    },
    orders: {
        name: 'orders',
        icon: 'clipboard-document-list',
        color: 'amber',
        search: true,
    },
}
